'use client'

import { createContext, useContext, useMemo, type ReactNode } from 'react'
import { reviveFirestoreJson } from '@/lib/branded-report/revive-json'
import type { BrandedBootstrapPayload } from '@/lib/branded-report/types'

export type SerializedBrandedBootstrap = Record<string, unknown> | null

const BootstrapContext = createContext<BrandedBootstrapPayload | null>(null)

export const BrandedReportBootstrapProvider = ({
  value,
  children
}: {
  value: SerializedBrandedBootstrap
  children: ReactNode
}) => {
  const revived = useMemo((): BrandedBootstrapPayload | null => {
    if (!value) return null
    return reviveFirestoreJson(value) as BrandedBootstrapPayload
  }, [value])

  return <BootstrapContext.Provider value={revived}>{children}</BootstrapContext.Provider>
}

export const useBrandedReportBootstrap = () => useContext(BootstrapContext)
